import angular from 'angular';
import _ from 'lodash';

export const ComplianceService = (Restangular) => {

    const checkIfPositionIsGdprCompliant = async function ({ position }) {
        try {
            const locations = _.chain(position)
                .get('desiredCandidateProfile.selected')
                .find({ field: 'locations' })
                .get('items')
                .value();

            const response = await Restangular.all('compliance')
                .all('position')
                .all('gdpr')
                .post({ locations });

            const isGdpr = !!response.result;
            return isGdpr;
        } catch {
            return false;
        }
    };

    return {
        checkIfPositionIsGdprCompliant,
    };
};

angular
    .module('TALENYA-FE')
    .factory('ComplianceService', ComplianceService);
